export const EnvironmentHelper = {

    isProduction: () => process.env.REACT_APP_ENVIRONMENT === 'production',
    
    isDevelopment: () => process.env.REACT_APP_ENVIRONMENT === 'development',

    isLocal: () => process.env.REACT_APP_ENVIRONMENT === 'local',

}